import React from 'react';
// Components
import {Row} from 'antd';
// Styles
import './activityLog.scss';
import { List, Typography } from 'antd';

function ActivityLogPage() {
    const data = [
        'Racing car sprays burning fuel into crowd.',
        'Japanese princess to wed commoner.',
        'Australian walks 100km after outback crash.',
        'Man charged over missing wedding girl.',
        'Los Angeles battles huge wildfires.',
    ];
    return (
        <div className='Form-edit-page'>
            <Row>
                <div className='section-container'>
                    <List
                        header={<div>Header</div>}
                        footer={<div>Footer</div>}
                        bordered
                        dataSource={data}
                        renderItem={item => (
                            <List.Item>
                                <Typography.Text mark>[ITEM]</Typography.Text> {item}
                            </List.Item>
                        )}
                    />
                </div>
            </Row>
        </div>
    )
}

export default ActivityLogPage;
